<template>
	<div class="shop-addr-page">
		
		<!-- ====== 面包屑导航 ====== -->
		<div class="breadcrumb-bar animate__animated animate__fadeIn">
			<div class="breadcrumb-left">
				<span class="bc-label">{{$t('header.breadcrumb.label')}}</span>
				<span class="bc-item">{{$t('shopAddr.t1')}}</span>
				<el-image class="bc-arrow" :src="require('@/static/CodeBuddyAssets/30841_3727/11.svg')"></el-image>
				<span class="bc-item">{{$t('shopAddr.t2')}}</span>
				<el-image class="bc-arrow" :src="require('@/static/CodeBuddyAssets/30841_3727/12.svg')"></el-image>
				<span class="bc-item bc-active">{{$t('shopAddr.t3')}}</span>
			</div>
			<div class="breadcrumb-right">
				<span class="bc-back-text">{{$t('header.breadcrumb.backBtn')}}</span>
				<el-image class="bc-back-icon" :src="require('@/static/CodeBuddyAssets/30841_3727/13.svg')"></el-image>
			</div>
		</div>

		<!-- ====== 表单卡片 ====== -->
		<div class="form-card animate__animated animate__fadeInUp">
			<!-- 标题 -->
			<div class="form-title-row">
				<el-image class="form-title-icon" :src="require('@/static/CodeBuddyAssets/30841_3727/10.svg')"></el-image>
				<h3 class="form-title">{{$t('shopAddr.t3')}}</h3>
			</div>

			<!-- 表单主体：两列布局 -->
			<div class="form-body">
				<!-- 左列 -->
				<div class="form-col">
					<div class="form-item">
						<label class="form-label">{{$t('shopAddr.t4')}}</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.name" :placeholder="$t('shopAddr.t10')" size="large"></el-input>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">{{$t('shopAddr.t5')}}</label>
						<div class="form-input-wrap">
							<el-select v-model="formData.country" :placeholder="$t('shopAddr.t11')" size="large">
								<el-option
									v-for="item in countryOptions"
									:key="item.value"
									:label="$t('shopAddr.' + item.label)"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">{{$t('shopAddr.t6')}}</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.district" :placeholder="$t('shopAddr.t12')" size="large"></el-input>
						</div>
					</div>
				</div>

				<!-- 右列 -->
				<div class="form-col">
					<div class="form-item">
						<label class="form-label">{{$t('shopAddr.t7')}}</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.phone" :placeholder="$t('shopAddr.t13')" size="large"></el-input>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">{{$t('shopAddr.t8')}}</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.city" :placeholder="$t('shopAddr.t14')" size="large"></el-input>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">{{$t('shopAddr.t9')}}</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.address" :placeholder="$t('shopAddr.t15')" size="large"></el-input>
						</div>
					</div>
				</div>
			</div>

			<!-- 保存按钮 -->
			<div class="form-footer">
				<div class="save-btn">{{$t('shopAddr.t16')}}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ShopAddr',
	data() {
		return {
			formData: {
				name: '',
				country: '',
				district: '',
				phone: '',
				city: '',
				address: ''
			},
			countryOptions: [
				{ value: 'china', label: 'c1' },
				{ value: 'usa', label: 'c2' },
				{ value: 'japan', label: 'c3' },
				{ value: 'korea', label: 'c4' },
				{ value: 'uk', label: 'c5' },
				{ value: 'germany', label: 'c6' },
				{ value: 'france', label: 'c7' },
				{ value: 'australia', label: 'c8' },
				{ value: 'canada', label: 'c9' },
				{ value: 'singapore', label: 'c10' },
			]
		}
	},
	methods: {
		//
	}
}
</script>

<style lang="scss" scoped>
.shop-addr-page {
	width: 100%;
	min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 60px;
}

/* ===================================================================
   面包屑导航
   =================================================================== */
.breadcrumb-bar {
	width: 1128px;
	margin: 0 auto;
	padding-top: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.breadcrumb-left {
	display: flex;
	align-items: center;
}
.bc-label {
	font-size: 16px;
	color: #333;
	font-weight: 400;
}
.bc-item {
	font-size: 16px;
	color: #666;
	font-weight: 400;
	margin: 0 4px;
}
.bc-item.bc-active {
	color: #0096FF;
}
.bc-arrow {
	width: 8px;
	height: 12px;
	margin: 0 8px;
}
.breadcrumb-right {
	display: flex;
	align-items: center;
	cursor: pointer;
}
.bc-back-text {
	font-size: 16px;
	color: #0096FF;
	font-weight: 400;
}
.bc-back-icon {
	width: 8px;
	height: 12px;
	margin-left: 6px;
}

/* ===================================================================
   表单卡片
   =================================================================== */
.form-card {
	width: 1128px;
	margin: 16px auto 0;
	background: #fff;
	border-radius: 12px;
	padding: 28px 28px 40px;
	box-sizing: border-box;
}

/* 标题 */
.form-title-row {
	display: flex;
	align-items: center;
	margin-bottom: 28px;
}
.form-title-icon {
	width: 10px;
	height: 16px;
	margin-right: 12px;
}
.form-title {
	font-size: 20px;
	font-weight: 500;
	color: #333;
	margin: 0;
}

/* 表单主体 */
.form-body {
	display: flex;
}
.form-col {
	width: 495px;
	flex-shrink: 0;
}
.form-col:first-child {
	margin-right: 32px;
}
.form-item {
	margin-bottom: 24px;
}
.form-label {
	display: block;
	font-size: 16px;
	color: #333;
	font-weight: 400;
	margin-bottom: 10px;
}

.form-input-wrap {
	width: 100%;
}
.form-input-wrap ::v-deep .el-input__inner,
.form-input-wrap ::v-deep .el-select .el-input__inner {
	height: 50px;
	line-height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	font-size: 16px;
	color: #333;
}
.form-input-wrap ::v-deep .el-input__inner::placeholder {
	color: #999;
}
.form-input-wrap ::v-deep .el-select .el-input__inner::placeholder {
	color: #999;
}
.form-input-wrap ::v-deep .el-select .el-input__suffix .el-input__suffix-inner {
	display: flex;
	align-items: center;
}
.form-input-wrap ::v-deep .el-select .el-icon-arrow-up:before {
	content: '';
}
.form-input-wrap ::v-deep .el-select .el-select__caret {
	color: #333;
	font-size: 12px;
}

/* 保存按钮 */
.form-footer {
	display: flex;
	justify-content: flex-end;
	margin-top: 8px;
}
.save-btn {
	width: 184px;
	height: 50px;
	background: #0096FF;
	border-radius: 10px;
	color: #fff;
	font-size: 16px;
	font-weight: 400;
	text-align: center;
	line-height: 50px;
	cursor: pointer;
	transition: background 0.3s;
}
.save-btn:hover {
	background: #33ABFF;
}
</style>
